import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Support from './pages/Support';
import Privacy from './pages/Privacy';

const App: React.FC = () => {
  return (
    <div className="vizo-shell min-h-screen overflow-x-hidden bg-slate-950 text-slate-50">
      <div className="pointer-events-none fixed left-[-12rem] top-[-10rem] h-[28rem] w-[28rem] rounded-full bg-brand-500/20 blur-3xl"></div>
      <div className="pointer-events-none fixed bottom-[-12rem] right-[-8rem] h-[24rem] w-[24rem] rounded-full bg-cyanGlow/10 blur-3xl"></div>
      <Navigation />
      <main className="pt-20 md:pt-24">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
